var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.981 26.221a2.373 2.373 0 001.738-.972l6.242-8.63a.667.667 0 00-.932-.93l-8.63 6.243a2.373 2.373 0 001.583 4.29zm-1.224-2.449a1.04 1.04 0 01.425-.761l5.265-3.809-3.808 5.263a1.043 1.043 0 01-1.882-.693z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.915 13.938c-.007-.014-.007-.028-.014-.042-.008-.014-.02-.021-.03-.034a18.127 18.127 0 00-2.376-3.206l1.432-1.431.943.943 2.828-2.83-2.828-2.827-2.83 2.828.944.943-1.432 1.432a18.1 18.1 0 00-3.206-2.378c-.012-.008-.02-.021-.033-.03-.014-.007-.029-.006-.043-.014a17.873 17.873 0 00-6.848-2.27V4.23h1c.919 0 1.666-.747 1.666-1.667S23.34.896 22.421.896h-6c-.92 0-1.667.747-1.667 1.666 0 .92.748 1.667 1.667 1.667h1v.77c-.72.077-1.439.195-2.15.357a.666.666 0 10.299 1.3c.613-.141 1.232-.247 1.853-.318l.715-.056a21.4 21.4 0 01.616-.038v1.318a.666.666 0 101.334 0V6.25c2.507.115 4.87.789 6.97 1.897l-.657 1.138a.667.667 0 001.155.666l.655-1.135a16.795 16.795 0 015.181 5.181l-1.135.656a.666.666 0 00.668 1.154l1.138-.657a16.546 16.546 0 011.9 7.08h-1.317a.666.666 0 100 1.333h1.316a16.546 16.546 0 01-1.9 7.079l-1.137-.657a.666.666 0 10-.667 1.154l1.136.656a16.796 16.796 0 01-5.182 5.18l-.655-1.134a.666.666 0 10-1.155.666l.658 1.138a16.537 16.537 0 01-6.971 1.897v-1.312a.666.666 0 10-1.333 0v1.317a16.82 16.82 0 01-3.184-.411.666.666 0 10-.298 1.3c1.33.306 2.69.46 4.038.46l.097-.002c.005 0 .008.003.012.003.005 0 .01-.004.015-.004a17.883 17.883 0 008.813-2.382c.02-.01.043-.014.063-.026.013-.008.02-.02.033-.03a18.13 18.13 0 006.515-6.506c.013-.018.029-.032.04-.052.008-.014.008-.03.014-.043a17.871 17.871 0 002.398-8.957c0-3.26-.875-6.318-2.397-8.958zm-.046-7.542l.943.943-.943.943-.943-.943.943-.943zM18.754 4.91V2.896h-2.333a.334.334 0 01-.333-.334c0-.183.15-.333.333-.333h6c.183 0 .333.15.333.333 0 .184-.15.334-.333.334h-2.333V4.91c-.232-.01-.454-.014-.667-.014h-.109c-.11 0-.218.007-.328.009-.077.002-.15.001-.23.005z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.42 10.229h-3.332a.666.666 0 100 1.333h3.333a.666.666 0 100-1.333z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.42 14.896H6.755a.666.666 0 100 1.333h6.667a.666.666 0 100-1.333z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.42 19.562h-10a.666.666 0 100 1.334h10a.666.666 0 100-1.334z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.42 24.229H.755a.666.666 0 100 1.333h12.667a.666.666 0 100-1.333z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.42 28.896H4.755a.666.666 0 100 1.333h8.667a.666.666 0 100-1.333z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.42 33.562H8.755a.666.666 0 100 1.334h4.667a.666.666 0 100-1.334z",
    fill: "url(#paint7_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 17.421,
    y1: 20.808,
    x2: 28.087,
    y2: 20.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C28D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA9865"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 14.754,
    y1: 20.568,
    x2: 37.698,
    y2: 20.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C28D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA9865"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 9.421,
    y1: 10.885,
    x2: 14.088,
    y2: 10.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C28D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA9865"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 6.087,
    y1: 15.551,
    x2: 14.088,
    y2: 15.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C28D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA9865"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 2.754,
    y1: 20.218,
    x2: 14.088,
    y2: 20.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C28D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA9865"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 0.087,
    y1: 24.885,
    x2: 14.088,
    y2: 24.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C28D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA9865"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 4.087,
    y1: 29.551,
    x2: 14.087,
    y2: 29.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C28D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA9865"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 8.087,
    y1: 34.218,
    x2: 14.088,
    y2: 34.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C28D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA9865"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.2bc7ac315f5bd9e63d3123e5581239d4.svg";
export { ForwardRef as ReactComponent };